import { render, staticRenderFns } from "./nickAndAvatar.vue?vue&type=template&id=75c03fab&scoped=true"
import script from "./nickAndAvatar.vue?vue&type=script&lang=js"
export * from "./nickAndAvatar.vue?vue&type=script&lang=js"
import style0 from "./nickAndAvatar.vue?vue&type=style&index=0&id=75c03fab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c03fab",
  null
  
)

export default component.exports